<template>
  <el-dialog
    title="修改公告"
    :visible.sync="announcementDetailDialogVisible"
    @close="closeDialog"
  >
    <el-form
      :model="announcementDetail"
      ref="form"
      label-width="140px"
      class="announcement-form"
    >
      <el-form-item
        label="分类："
        prop="categoryId"
        :rules="[{ required: true, message: '分类不能为空' }]"
      >
        <el-select
          :value="announcementDetail.categoryId"
          @input="handleSetAnnouncementDetail('categoryId', $event)"
          placeholder="请选择"
        >
          <el-option
            v-for="item in categoryList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="语言类型："
        prop="language"
        :rules="[{ required: true, message: '语言类型不能为空' }]"
      >
        <el-select
          :value="announcementDetail.language"
          @input="handleSetAnnouncementDetail('language', $event)"
          placeholder="请选择"
        >
          <el-option
            v-for="item in languageList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="title"
        label="标题"
        :rules="[{ required: true, message: '标题不能为空' }]"
      >
        <el-input
          type="text"
          :value="announcementDetail.title"
          @input="handleSetAnnouncementDetail('title', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="content"
        label="内容"
        :rules="[{ required: true, message: '内容不能为空' }]"
      >
        <editor
          :value="announcementDetail.content"
          @input="handleSetAnnouncementDetail('content', $event)"
          class="editor"
        ></editor>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave('form')">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Editor from 'components/editor';
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'UpdateAnnouncement',
  components: {
    Editor
  },
  computed: {
    ...mapState('announcement', [
      'languageList',
      'announcementDetailDialogVisible',
      'announcementDetail'
    ]),
    ...mapGetters('announcement', ['categoryList'])
  },
  methods: {
    ...mapActions('announcement', ['update']),
    ...mapMutations('announcement', [
      'setAnnouncementDetailDialogVisible',
      'setAnnouncementDetail'
    ]),
    closeDialog() {
      this.setAnnouncementDetailDialogVisible(false);
    },
    handleSetAnnouncementDetail(type, value) {
      this.setAnnouncementDetail({
        ...this.announcementDetail,
        [type]: value
      });
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.update(this.announcementDetail).then(() => {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.setAnnouncementDetailDialogVisible(false);
            this.$emit('onUpdated');
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.announcement-form {
  margin-right: 100px;
}
.editor {
  height: 500px;
}
</style>
